import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { BusinessScheduleComponent } from './business-schedule.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule
  ],
  declarations: [BusinessScheduleComponent],
  exports: [BusinessScheduleComponent]
})
export class BusinessScheduleModule {}
